// External Dependencies:
import React from 'react'
const uuidv4 = require( 'uuid/v4' )

// Internal Dependencies:
import Calendar from './Calendar'

class EventsCalendar extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			value: props.value,
			hasError: false,
			dates: false
		}
	}

	componentDidMount() {
		// Ensure an initial date is set and sent through,
		// allowing the user to continue without selecting a date (default to today).
		this.handleChange( new Date() )
		this.setupDates()
	}

	componentDidUpdate( prevProps ) {
	  const { eventsById } = this.props

	  if ( eventsById != prevProps.eventsById ) {
	  	this.setupDates()
	  }
	}

	handleChange = ( value ) => {
		// Ensure the date value is within the day:
		value.setHours( 12 )

		this.setState( {
			value: value
		} )
	}

	setupDates = () => {
		const { eventsById } = this.props
		let dates = {}

		if ( ! eventsById ) {
			return
		}

		// Each event:
		Object.keys( eventsById ).map( key => {
			let item = eventsById[ key ],
				datesNumber = item.dates.length,
				position = 0

			// Each date for this event:
			// Get the index:
			item.dates.map( ( date, i ) => {
				if ( dates[ date['y-m-d'] ] ) {
					let thisPosition = dates[ date['y-m-d'] ].length

					if ( thisPosition > position ) {
						position = thisPosition
					}
				}
			} )

			// Each date for this event:
			item.dates.map( ( date, i ) => {
				if ( ! dates[ date['y-m-d'] ] ) {
					dates[ date['y-m-d'] ] = []
				}

				let isFirst = ( 0 === i ) ? true : false

				dates[ date['y-m-d'] ][ position ] = {
					...item,
					is_first: isFirst,
					is_last_and_first: ( 0 === i && datesNumber === i + 1 ) ? true : false,
					is_last_not_first: ( 0 !== i && datesNumber === i + 1 ) ? true : false,
					position: position
				}
			} )
		} )

		// Pad each date:
		Object.keys( dates ).map( key => {
			let dateItems = dates[ key ],
				length = dateItems.length,
				desiredLength = 0

			for ( let i = 0; i < length; i++ ) {
				if ( ! dateItems[ i ] ) {
					dates[ key ][ i ] = {
						id: uuidv4(),
						is_empty: true
					}
				}
			}
		} )

		this.setState( {
			dates: dates
		} )
	}

	renderTileContent = ( { year, monthNumberPadded, dayNumberPadded, dayOfWeekNumber } ) => {
		const { dates } = this.state
		let markup,
			expandedMarkup

		if ( dates[ `${year}-${monthNumberPadded}-${dayNumberPadded}` ] ) {
			expandedMarkup = dates[ `${year}-${monthNumberPadded}-${dayNumberPadded}` ].map( item => {
				if ( item.is_empty ) {
					return
				}

				return (
					<div className="-item">
						{ item.title } -&nbsp;

						{ item.date_display &&
							<span className="-title-date">
								{ item.date_display.start }

								{ item.date_display.end &&
									<span>- { item.date_display.end }</span>
								}
							</span>
						}
					</div>
				)
			} )
			expandedMarkup.filter( Boolean )

			markup = dates[ `${year}-${monthNumberPadded}-${dayNumberPadded}` ].map( item => {
				let className = '-day-item',
					style = {}

				if ( item.is_first ) {
					className += ' is-first'
				}

				if ( item.is_last_and_first ) {
					className += ' is-last-and-first'
				}

				if ( item.is_last_not_first ) {
					className += ' is-last-not-first'
				}

				if ( item.is_empty ) {
					className += ' is-empty'
				}

				if ( item.color ) {
					style.backgroundColor = item.color
				}

				return (
					<div className={ className } key={ item.id }>
						<div className="-inner" style={ style }>
							{ ( 7 == dayOfWeekNumber || ( item.is_first && ! item.is_empty ) ) &&
								<div className="-title">
									{ item.title } -&nbsp;

									{ item.date_display &&
										<span className="-title-date">
											{ item.date_display.start }

											{ item.date_display.end &&
												<span>- { item.date_display.end }</span>
											}
										</span>
									}
								</div>
							}
						</div>
					</div>
				)
			} )
		}

		if ( ! markup ) {
			return
		}

		return (
			<div className="-inner">
				{ markup }

				{ expandedMarkup &&
					<div className="-expanded">
						{ expandedMarkup }
					</div>
				}
			</div>
		)
	}

	render() {
		const { eventsById } = this.props
		const { value } = this.state

		return (
			<div className="events-calendar">
				<Calendar
					onChange={ this.handleChange }
					value={ value }
					renderTileContent={ this.renderTileContent }
				/>
			</div>
		)
	}
}

export default EventsCalendar
